import { render, staticRenderFns } from "./Fleet.vue?vue&type=template&id=fa2c9d34&scoped=true"
import script from "./Fleet.vue?vue&type=script&lang=js"
export * from "./Fleet.vue?vue&type=script&lang=js"
import style0 from "./Fleet.vue?vue&type=style&index=0&id=fa2c9d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2c9d34",
  null
  
)

export default component.exports